import React from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import api from "../api/api/index";
import { Modal } from "antd";
import { defaultFormValues } from "../api/requiredFunctions";
import { saveCashRequestDto } from "../redux-stuffs/actions/profile_action";
import { accessTokenState, nameState, phoneState, emailState, merchantAddressState, merchantNameState, amountState } from '../atoms';
import withRecoil from '../withRecoil';
import _ from 'lodash';
import queryString from "query-string";
import Header from "../components/Header";
import DashboardWithActions from "./DashboardWithActions";
import AmountAvailable from "./PickUpCash/AmountAvailable";
import DashboardLocationMap from "../components/DashboardLocationMap";
import { withTranslation } from "react-i18next";
import { GOOGLE_MAPS_API_KEY } from "../config/google";
import "./PickUpCash/styles/LocationSelector.css";

function error(title, content) {
  Modal.error({
    title: title,
    content: content,
  });
}

class DashboardMain extends React.Component {
  constructor(props) {
    super(props);
    this.demoOptions = props.demoOptions || {};

    const initialCenter = this.demoOptions.initialCenter || null;
    const initialAddress = this.demoOptions.initialAddress || '';
    const initialZip = this.demoOptions.initialZipcode || '';
    const initialBusinesses = Array.isArray(this.demoOptions.initialBusinesses) ? this.demoOptions.initialBusinesses : [];
    const initialRequestedAmount = typeof this.demoOptions.initialRequestedAmount === 'number'
      ? this.demoOptions.initialRequestedAmount
      : null;

    const initialLocationContext = initialCenter
      ? {
          address: initialAddress,
          zipcode: initialZip,
          requested_amount: initialRequestedAmount,
          lat: initialCenter.lat,
          long: initialCenter.lng,
          uuid: null,
        }
      : null;

    this.state = {
      escrow_amount: typeof this.demoOptions.initialBalance === 'number' ? this.demoOptions.initialBalance : null,
      showBanner: false,
      showPayment: false,
      userAddress: initialAddress,
      mapCenter: initialCenter,
      isMapLoading: false,
      mapError: '',
      businesses: initialBusinesses,
      selectedBusiness: null,
      isLocationModalOpen: false,
      locationContext: initialLocationContext,
      isSubmittingSelection: false,
      amountPromptKey: 0,
      isSearchingLocations: false,
      searchReason: '',
    };
  }

  componentDidMount() {
    const skipAccountRequests = Boolean(this.demoOptions.disableAccountRequests);
    const skipLocationFetch = Boolean(this.demoOptions.skipUserLocationFetch);

    if (!skipAccountRequests) {
      this.updateEscrow();
      this.checkEmailVerification();
      this.getAccountInfo();
    } else if (typeof this.demoOptions.initialBalance === 'number') {
      this.setState({ escrow_amount: this.demoOptions.initialBalance });
    }

    if (!skipLocationFetch) {
      this.fetchUserLocation();
    } else if (this.demoOptions.initialCenter) {
      this.setState({
        mapCenter: this.demoOptions.initialCenter,
        userAddress: this.demoOptions.initialAddress || this.state.userAddress,
      });
    }
  }

  checkEmailVerification = () => {
    let body = {
      access_token: this.props.recoilStates.accessTokenState.state,
      device_type: 5,
      device_token: 1,
      app_version: 1,
    };
    fetch(`${api.main}/access_token_login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: queryString.stringify(body),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Status: ${response.status}`);
        }
        return response.json();
      })
      .then(res => {
        if (res.status === 105 && res.data.email_verified === 0) {
          this.setState({ showBanner: true });
        }
      })
      .catch(err => {
        console.error('Error verifying access:', err);
      });
  }

  getAccountInfo = () => {
    fetch(`${api.main}/get_user_profile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        access_token: this.props.token,
      }),
    })
      .then(res => {
        if (!res.ok) {
          return res.json().then(errorData => {
            throw new Error(`Error: ${errorData.message}`);
          });
        }
        return res.json();
      })
      .then(data => {
        if (data.status !== 105) {
          throw new Error(`Error: ${data.message}`);
        } else {
          if (typeof data.data.name !== 'undefined' && typeof data.data.phone !== 'undefined') {
            this.props.recoilStates[nameState.key].setState(data.data.name);
            this.props.recoilStates[phoneState.key].setState(data.data.phone);
            this.props.recoilStates[accessTokenState.key].setState(this.props.token);
          } else {
            // log properly instead of calling the helper
            console.error('Missing name/phone in profile payload');
          }
        }
      })
      .catch(err => {
        console.error('Error getting account info:', err);
      });
  };

  fetchUserLocation = () => {
    if (this.demoOptions.skipUserLocationFetch) {
      return;
    }
    const { token, t } = this.props;
    if (!token) {
      return;
    }

    this.setState({ isMapLoading: true, mapError: '' });

    const headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
    const body = queryString.stringify({ access_token: token });

    fetch(`${api.extra}/api/get_user_information`, {
      method: 'POST',
      headers,
      body,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        const user = _.get(data, 'user', {});
        const addressParts = [
          user.address,
          user.city,
          user.state,
          user.zipcode,
          user.country,
        ].filter(Boolean);

        if (!addressParts.length) {
          this.setState({
            isMapLoading: false,
            mapError: t('displayMain:map.noAddress'),
          });
          return;
        }

        const formattedAddress = addressParts.join(', ');
        this.setState({ userAddress: formattedAddress });
        this.geocodeAddress(formattedAddress);
      })
      .catch(() => {
        this.setState({
          isMapLoading: false,
          mapError: t('displayMain:map.loadError'),
        });
      });
  };

  geocodeAddress = (address) => {
    if (!address) {
      this.setState({ isMapLoading: false });
      return;
    }

    const apiKey = GOOGLE_MAPS_API_KEY;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Status: ${response.status}`);
        }
        return response.json();
      })
      .then(result => {
        if (result.status === 'OK' && result.results && result.results.length) {
          const location = _.get(result, 'results[0].geometry.location');
          if (location && typeof location.lat === 'number' && typeof location.lng === 'number') {
            this.setState({
              mapCenter: { lat: location.lat, lng: location.lng },
              isMapLoading: false,
              mapError: '',
            });
            return;
          }
        }
        this.setState({
          isMapLoading: false,
          mapError: this.props.t('displayMain:map.loadError'),
        });
      })
      .catch(() => {
        this.setState({
          isMapLoading: false,
          mapError: this.props.t('displayMain:map.loadError'),
        });
      });
  };

  handleDashboardLocationChange = ({ lat, lng, address }) => {
    if (typeof lat !== 'number' || typeof lng !== 'number') {
      return;
    }
    this.setState({
      mapCenter: { lat, lng },
      userAddress: address || this.state.userAddress,
      isMapLoading: false,
      mapError: '',
    });
  };

  handleBusinessesLoaded = (businesses, location = {}) => {
    const nextLocationContext = this.buildLocationContext(location, this.state.locationContext);

    if (location && location.isSearching) {
      this.setState({
        isSearchingLocations: true,
        mapError: '',
        locationContext: nextLocationContext,
        searchReason: location.searchReason || 'location',
      });
      return;
    }

    const hasLatLng = typeof nextLocationContext.lat === 'number' && typeof nextLocationContext.long === 'number';
    const nextCenter = hasLatLng
      ? { lat: nextLocationContext.lat, lng: nextLocationContext.long }
      : this.state.mapCenter;

    this.setState({
      businesses: Array.isArray(businesses) ? businesses : [],
      mapCenter: nextCenter,
      userAddress: nextLocationContext.address,
      locationContext: nextLocationContext,
      isMapLoading: false,
      mapError: '',
      isSearchingLocations: false,
      searchReason: '',
    });
  };

  buildLocationContext = (location = {}, fallback = {}) => {
    const resolved = location || {};
    const previous = fallback || {};
    const address = resolved.address || previous.address || this.state.userAddress;

    return {
      address,
      zipcode: resolved.zipcode || previous.zipcode || '',
      requested_amount: resolved.requested_amount || previous.requested_amount || null,
      lat: typeof resolved.lat === 'number' ? resolved.lat : previous.lat,
      long: typeof resolved.long === 'number' ? resolved.long : previous.long,
      uuid: resolved.uuid || previous.uuid || null,
    };
  };

  handleDashboardMarkerClick = (business) => {
    if (!business) {
      return;
    }
    const { locationContext } = this.state;
    if (!locationContext || !locationContext.requested_amount) {
      this.setState(prevState => ({ amountPromptKey: prevState.amountPromptKey + 1 }));
      return;
    }
    this.setState({
      selectedBusiness: business,
      isLocationModalOpen: true,
    });
  };

  closeDashboardLocationModal = () => {
    this.setState({
      isLocationModalOpen: false,
      selectedBusiness: null,
    });
  };

  openSelectedBusinessDirections = () => {
    const { selectedBusiness } = this.state;
    if (!selectedBusiness || !selectedBusiness.address) {
      return;
    }
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(selectedBusiness.address)}`;
    window.open(url, '_blank');
  };

  handleDashboardSelect = () => {
    const { locationContext, selectedBusiness } = this.state;
    const { t } = this.props;
    if (
      !selectedBusiness ||
      !locationContext ||
      !locationContext.requested_amount ||
      !selectedBusiness.registration_id
    ) {
      return;
    }

    const accessToken = this.props.recoilStates.accessTokenState.state;
    if (!accessToken) {
      error(t('location:errors.generic_title'), t('location:errors.internal_server'));
      return;
    }

    const finalBody = {
      ...defaultFormValues(),
      amount: locationContext.requested_amount,
      currency: 1,
      agent_registration_id: selectedBusiness.registration_id,
      access_token: accessToken,
    };

    const fee = typeof selectedBusiness.surcharge === 'number' ? selectedBusiness.surcharge : 0;
    const isDemoMode = typeof this.demoOptions.onDemoPickupSelect === 'function';

    if (isDemoMode) {
      this.props.recoilStates.merchantAddressState?.setState(selectedBusiness.address);
      this.props.recoilStates.merchantNameState?.setState(selectedBusiness.business_name);
      this.props.recoilStates.amountState?.setState(locationContext.requested_amount);
      this.setState({ isLocationModalOpen: false, isSubmittingSelection: false });
      this.demoOptions.onDemoPickupSelect({
        zipcode: selectedBusiness.zipcode,
        fee,
        uuid: locationContext.uuid,
        merchant: selectedBusiness.business_name,
        address: selectedBusiness.address,
        amount: locationContext.requested_amount,
      });
      return;
    }

    this.setState({ isSubmittingSelection: true });

    fetch(`${api.main}/send_cash_request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: queryString.stringify(finalBody),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(res => {
        this.setState({ isSubmittingSelection: false });
        if (res.status !== 104) {
          error(t('location:errors.generic_title'), res.message || t('location:errors.send_cash_failed'));
          return;
        }

        this.props.recoilStates.merchantAddressState?.setState(selectedBusiness.address);
        this.props.recoilStates.merchantNameState?.setState(selectedBusiness.business_name);
        this.props.recoilStates.amountState?.setState(locationContext.requested_amount);

        this.props.saveCashRequestDto(res.data)
          .then(() => {
            this.setState({ isLocationModalOpen: false });
              this.props.history.push({
                pathname: '/dashboard/pickup',
                state: {
                  zipcode: selectedBusiness.zipcode,
                  fee,
                  uuid: locationContext.uuid,
                  fromDemo: Boolean(this.demoOptions.embedMobileLayout),
                },
              });
          })
          .catch(() => {
            this.setState({ isLocationModalOpen: false });
              this.props.history.push({
                pathname: '/dashboard/pickup',
                state: {
                  zipcode: selectedBusiness.zipcode,
                  fee,
                  uuid: locationContext.uuid,
                  fromDemo: Boolean(this.demoOptions.embedMobileLayout),
                },
              });
          });
      })
      .catch(err => {
        this.setState({ isSubmittingSelection: false });
        error(t('location:errors.generic_title'), err.message || t('location:errors.send_cash_failed'));
      });
  };

  renderDashboardLocationModal = () => {
    const { isLocationModalOpen, selectedBusiness, isSubmittingSelection } = this.state;
    const { t } = this.props;
    if (!isLocationModalOpen || !selectedBusiness) {
      return null;
    }
    const fee = typeof selectedBusiness.surcharge === 'number' ? selectedBusiness.surcharge : 0;

    return (
      <div className="ls-overlay" onClick={this.closeDashboardLocationModal}>
        <div className="location-info ls-location-info" onClick={(e) => e.stopPropagation()}>
          <div className="ls-modal-closebar">
            <button className="ls-close-btn" onClick={this.closeDashboardLocationModal}>
              <p className="ls-close-text">X</p>
            </button>
          </div>

          <div><h3 className="ls-selected-label">{t('location:selected_merchant')}</h3></div>
          <div><h1 className="ls-display-4">{selectedBusiness.business_name || t('displayMain:map.unknownBusiness')}</h1></div>
          <div><h3 className="ls-fee">
            {t('location:transaction_fee')}: ${fee.toFixed(2)}
          </h3></div>
          <div><p className="ls-address">{selectedBusiness.address}</p></div>

          {selectedBusiness.banner_url && (
            <div>
              <p className="sponsored-by">{t('location:sponsored_by')}</p>
              <img
                className="ls-sponsor-image"
                src={selectedBusiness.banner_url}
                alt={selectedBusiness.sponsor_name || selectedBusiness.business_name || 'sponsor'}
              />
            </div>
          )}

          <div className="ls-actions">
            <button className="action-button btn" onClick={this.openSelectedBusinessDirections}>
              {t('location:directions')}
            </button>
            <button
              className={`action-button btn ${isSubmittingSelection ? 'disabled' : ''}`}
              onClick={this.handleDashboardSelect}
              disabled={isSubmittingSelection}
            >
              {isSubmittingSelection ? `${t('location:select')}...` : t('location:select')}
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderDashboardLocationTags = () => {
    const { businesses } = this.state;
    const { t } = this.props;
    const hasBusinesses = Array.isArray(businesses) && businesses.length > 0;

    return (
      <div className="dashboard-location-tags">
        <p className="dashboard-location-tags-label">{t('displayMain:map.locationsLabel')}</p>
        {hasBusinesses ? (
          <>
            <div className="dashboard-location-tags-list">
              {businesses.map((business) => (
                <button
                  type="button"
                  key={business.registration_id || business.id || business.address}
                  className="dashboard-location-tag"
                  onClick={() => this.handleDashboardMarkerClick(business)}
                >
                  {business.business_name || business.address}
                </button>
              ))}
            </div>
            <p className="dashboard-map-hint">{t('displayMain:map.zoomHint')}</p>
          </>
        ) : (
          <p className="dashboard-map-tags-empty">
            {t('displayMain:map.noLocations')}
          </p>
        )}
      </div>
    );
  };

  updateEscrow = () => {
    let body = {
      access_token: this.props.token,
      device_type: 5,
      device_token: 1,
      app_version: 1,
    };
    fetch(`${api.main}/access_token_login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: queryString.stringify(body),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(res => {
        if (res.status !== 105) {
          error("Error", res.message);
        } else {
          const escrow_amount = _.get(res, 'data.escrow_amount');
          this.setState({ escrow_amount });
          this.props.profile.escrow_amount = res.data.escrow_amount;
        }
      })
      .catch(() => {
        this.props.history.push({ pathname: 'login' });
      });
  };

  togglePayment = () => {
    this.setState(prevState => ({ showPayment: !prevState.showPayment }));
  };

  render() {
    const escrow_amount = _.get(this.state, 'escrow_amount', null);
    const {
      showBanner,
      userAddress,
      mapCenter,
      isMapLoading,
      mapError,
      isSearchingLocations,
      searchReason,
    } = this.state;

    let balance = 0;
    if (escrow_amount > 0) {
      let amount = escrow_amount.toFixed(2);
      let number = amount.toString();
      balance = number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const { t } = this.props;

    const hasBusinesses = Array.isArray(this.state.businesses) && this.state.businesses.length > 0;
    const showSearchIndicator = isSearchingLocations && (searchReason !== 'amount' || !hasBusinesses);
    const mapStatusBase = mapError || (isMapLoading ? t('displayMain:map.loading') : t('displayMain:map.noAddress'));
    const mapStatus = showSearchIndicator ? t('displayMain:map.searching') : mapStatusBase;
    const mapSubtext = showSearchIndicator
      ? t('displayMain:map.searching')
      : (hasBusinesses ? t('displayMain:map.zoomHint') : t('displayMain:map.noLocations'));
    const mapAddress = userAddress || t('displayMain:map.noAddress');
    const embedMobileLayout = Boolean(this.demoOptions.embedMobileLayout);
    const showHeader = !this.demoOptions.hideHeader;
    const onlyDashboardWithActions = Boolean(this.demoOptions.onlyDashboardWithActions);

    const dashboardWithActions = (
      <DashboardWithActions
        t={t}
        balance={balance}
        pickUpLink="/dashboard/amount-available"
        addBalanceLink="/add-to-balance"
        hideAddBalanceButton={Boolean(this.demoOptions.hideAddBalanceButton)}
        onLocationChange={this.handleDashboardLocationChange}
        onBusinessesLoaded={this.handleBusinessesLoaded}
        amountPromptKey={this.state.amountPromptKey}
        embedMobileLayout={embedMobileLayout}
        mapCenter={mapCenter}
        mapStatus={mapStatus}
        mapSubtext={mapSubtext}
        mapAddress={mapAddress}
        showSearchIndicator={showSearchIndicator}
        mapError={mapError}
        isMapLoading={isMapLoading}
        businesses={this.state.businesses}
        onMarkerClick={this.handleDashboardMarkerClick}
      />
    );

    if (onlyDashboardWithActions) {
      return (
        <React.Fragment>
          {dashboardWithActions}
          {this.renderDashboardLocationModal()}
        </React.Fragment>
      );
    }

    return (
      <div>
        {showHeader && <Header />}
        {/* Email verification banner */}
        {showBanner && (
          <div className="banner">
            {t('displayMain:banner.verifyEmail')}
            <span
              onClick={() => this.props.history.push({ pathname: "/edit-profile" })}
              className="link"
              role="button"
            >
              {t('displayMain:banner.clickHere')}
            </span>
            .
          </div>
        )}
        <div className="dashboard-container" style={{ overflowY: "hidden" }}>
          <div className="whitelabel"></div>
          {dashboardWithActions}
          {!embedMobileLayout && (
            <div className="dashboard-map-card">
              <div className="dashboard-map-header">
                <h3>{t('displayMain:map.title')}</h3>
                <p className="dashboard-map-address">
                  {mapSubtext}
                </p>
                <p className="ls-radius-note">
                  {t('location:radius_note')}
                </p>
              </div>
              <div className="dashboard-map-inner">
                {mapCenter && !mapError && !isMapLoading ? (
                  <DashboardLocationMap
                    center={mapCenter}
                    businesses={this.state.businesses}
                    onMarkerClick={this.handleDashboardMarkerClick}
                  />
                ) : (
                  <div className="map-placeholder">{mapStatus}</div>
                )}
              </div>
              {/* {this.renderDashboardLocationTags()} */}
            </div>
          )}
        </div>
        {this.renderDashboardLocationModal()}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ saveCashRequestDto }, dispatch);

const mapStateToProps = state => ({
  token: state.token,
  profile: state.profile,
});

// Wrap with withTranslation to inject `t` into props
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withRecoil(withTranslation(['displayMain', 'location', 'amountAvailable'])(DashboardMain), [accessTokenState, nameState, phoneState, emailState, merchantAddressState, merchantNameState, amountState])));
